import { render, staticRenderFns } from "./ResponsavelEdit.vue?vue&type=template&id=627bea98&"
import script from "./ResponsavelEdit.vue?vue&type=script&lang=js&"
export * from "./ResponsavelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports